<template>
  <div class="file-upload">
    <div v-if="onUpload" class="file-upload__inner-wrapper">
      <input @change="handleInput" :name="name" :id="id" type="file" />
      <label
        :for="id"
        :class="['file-upload__name', { warning: fieldIsEmpty }]"
        >{{ label }}</label
      >
      <base-button
        @click.native.prevent.stop="handleDownloadClick"
        :disabled="disabled"
        :fluid="false"
        class="file-upload__button"
        >{{ buttonText }}</base-button
      >
    </div>
    <template v-else>
      <span class="file-upload__file-name">{{ label }}</span>
      <base-link
        v-if="editable"
        path
        @click.native.prevent.stop="onUpload = true"
        >modifier</base-link
      >
    </template>
    <span v-if="alert" class="file-upload__alert">{{ alert }}</span>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: "Ficher..."
    },

    buttonText: {
      type: String,
      default: "Télécharger"
    },
    acceptedTypes: {
      type: Array,
      default: () => ["*"]
    },
    error: {
      type: Boolean,
      default: false
    },
    upload: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      id: `fu_${this.name}`,
      disabled: true,
      label: this.placeholder,
      file: null,
      alert: null,
      onUpload: this.upload,
      fieldIsEmpty: this.error
    }
  },
  methods: {
    handleInput(event) {
      this.alert = null
      this.fieldIsEmpty = null
      const file = event.target.files[0]
      if (this.acceptedTypes.indexOf(file.type) === -1) {
        this.alert = `Fichiers [${this.acceptedTypes.toString()}] seulement.`
        return
      }
      this.label = file.name
      this.disabled = false
      this.file = file

      this.onUpload = false
      this.$emit("file-upload", this.file)
    },
    handleDownloadClick() {}
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";

.file-upload {
  min-width: 400px;
  max-width: 100%;
  &__inner-wrapper {
    height: 50px;
    display: flex;
    flex-wrap: nowrap;
  }

  &__alert {
    color: $color-semantic--error;
    color: var(--color-semantic--error, $color-semantic--error);
  }

  input {
    visibility: hidden;
    height: 0;
    width: 0;
  }
  label {
    padding-left: 17px;
    padding-right: 18px;
    line-height: 50px;
    flex-grow: 1;
    border: 1px solid;
    border-color: $color-neutral-3;
    border-color: var(--color-neutral-3, $color-neutral-3);
    border-right: none;
    overflow: hidden;
    text-overflow: ellipsis;
    &.warning {
      border-right: none;
      border-color: $color-semantic--error;
      border-color: var(--color-semantic--error, $color-semantic--error);
    }
  }
  &__button.button {
    margin-left: auto;
    border-radius: 0;
    box-shadow: none !important;
  }
  &__file-name {
    display: block;
    width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: $color-neutral-4;
    color: var(--color-neutral-4, $color-neutral-4);
  }
}
</style>
